module.exports = __webpack_public_path__ + "img/area_9.67b062c2.png";